import angular from 'angular'
import modalAddCategories from './add-category.html'
import modalAddSubcategories from './add-subcategory.html'

let CategoriesListController = function (CategoriesService, $mdDialog, $filter, $scope, $state, Toast) {
  let $ctrl = this;
  $ctrl.$scope = $scope;
  angular.extend($ctrl, {
    newCategory,
    deleteDialog,
  });

  activate();

  function activate() {
    $ctrl.resources = {
      count: 0,
      data: []
    };

    $ctrl.uiState = 'LOADING';
    $ctrl.category = {
      name: ''
    }

    $ctrl.versionList = [];

    $ctrl.promise;

    $ctrl.$scope.tableConfig = {
      page: 1,
      limit: 10,
      order: 'updated_at'
    };

    $ctrl.$scope.$watch('tableConfig', () => {
      loadData()
    }, true);
  }


  function newCategory(resource) {
    console.log(resource)
    $mdDialog.show({
      template: modalAddCategories,
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: true,
      fullscreen: false,
      controller: CategoryDialogController,
      controllerAs: 'ctrl',
      locals: {
        title: resource ? 'common-edit' : 'common-create',
        category: resource,
      }
    })
      .then(function (resource) {
        saveCategory(resource)
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function newSubCategory(categoryId, subCategory) {
    $mdDialog.show({
      template: modalAddSubcategories,
      bindToController: true,
      parent: angular.element(document.body),
      clickOutsideToClose: false,
      escapeToClose: false,
      fullscreen: false,
      controller: SubcategoryDialogController,
      controllerAs: 'ctrl',
      locals: {
        title: subCategory ? 'common-edit' : 'common-create',
        categoryId,
        subCategory
      }
    })
      .then(function (resource) {
        resolveSubCategory(resource);
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      })
      .finally(function () {
        newCategory($ctrl.resources.data.find(el => el.id === categoryId));
      });
  }

  function deleteDialog(resource) {
    $mdDialog.show({
      template: '<md-dialog aria-label="Version dialog" style="max-width: 550px; padding: 24px;">' +
      '  <md-dialog-content>'+
      '  <h4><strong>EXCLUIR CATEGORIA</strong></h4>' +
      '  <div>Deseja realmente excluir a categoria selecionada?</div>' +
      '  </md-dialog-content>' +
      '  <md-dialog-actions>' +
      '    <md-button ng-click="cancel()">Cancelar</md-button>' +
      '    <md-button ng-click="save()" class="md-accent">Excluir</md-button>' +
      '  </md-dialog-actions>' +
      '</md-dialog>',
      controller: CategoryDialogController,
      bindToController: true,
      clickOutsideToClose: true,
      fullscreen: false
    })
      .then(function () {
        deleteCategory(resource.id);
      }, function () {
        $scope.status = 'You cancelled the dialog.';
      });
  }

  function CategoryDialogController($scope, $mdDialog) {
    "ngInject";

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function () {
      $mdDialog.cancel();
    };

    $scope.save = function (resource) {
      $mdDialog.hide(resource);
    }

    $scope.editSubCategory = function (categoryId, subCategory) {
      newSubCategory(categoryId, subCategory);
    }
  }

  function SubcategoryDialogController($scope, $mdDialog) {
    "ngInject";

    $scope.hide = function () {
      $mdDialog.hide();
    };

    $scope.cancel = function (categoryId, subCategory) {
      $mdDialog.cancel({categoryId, subCategory});
    };

    $scope.save = function (categoryId, subCategory) {
      $mdDialog.hide({action: 'SAVE', categoryId, subCategory});
    }

    $scope.delete = function (categoryId, subCategory) {
      $mdDialog.hide({action: 'DELETE', categoryId, subCategory});
    }
  }

  // Local functions

  function loadData() {
    $ctrl.promise = CategoriesService
      .load($ctrl.$scope.tableConfig)
      .then(response => {
        setPlaceHolderValues(response.data);
        $ctrl.resources = response;
        $ctrl.uiState = response.data.length ? 'COMPLETE' : 'EMPTY';
        $ctrl.$scope.$apply();
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      });
  }

  function setPlaceHolderValues(arr) {
  	_.forEach(arr, item => {
  		if (item.email === null || item.email === undefined) {
  			item.email = $filter('translate')('common-not-informed');
  		}
  	});
  }

  function saveCategory(resource) {
    $ctrl.promise = CategoriesService
      .save(resource)
      .then(response => {
        loadData()
      })
      .catch(err => {
        if(err.status === 409) {
          $mdDialog.show(
            $mdDialog.alert()
            .clickOutsideToClose(true)
            .textContent("A categoria já existe!")
            .ok("Ok")
          )
        }
        else{
          $ctrl.uiState = 'ERROR';
        }
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }

  function deleteCategory(id) {
    $ctrl.promise = CategoriesService
      .deleteCategory(id)
      .then(response => {
        loadData()
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }

  async function resolveSubCategory(resource) {
    const categoryIndex = $ctrl.resources.data.findIndex(
      el => el.id === resource.categoryId
    );

    if (resource.action === 'SAVE') {
      if (resource.subCategory.id) {
        updateSubCategory(resource);

        const subCategoryIndex = $ctrl.resources.data[
          categoryIndex
          ].subcategories.findIndex((el) => el.id === resource.subCategory.id);

        $ctrl.resources.data[categoryIndex].subcategories[
          subCategoryIndex
          ].name = resource.subCategory.name;
      } else {
        const newSub = await saveSubCategory(resource);
        $ctrl.resources.data[categoryIndex].subcategories.push(newSub);
      }
    }

    if (resource.action === 'DELETE') {
      deleteSubCategory(resource.subCategory.id);

      const subCategoryIndex = $ctrl.resources.data[
        categoryIndex
        ].subcategories.findIndex((el) => el.id === resource.subCategory.id);

      $ctrl.resources.data[categoryIndex].subcategories.splice(
        subCategoryIndex,
        1
      );
    }
  }

  async function saveSubCategory(resource) {
    return await CategoriesService
      .saveSubCategory(resource.categoryId, resource.subCategory.name)
      .then(response => {
        loadData();
        return response;
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }

  function updateSubCategory(resource) {    
    $ctrl.promise = CategoriesService
      .updateSubCategory(resource.subCategory.id, resource.subCategory.name)
      .then(response => {
        loadData()
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }

  function deleteSubCategory(id) {
    $ctrl.promise = CategoriesService
      .deleteSubCategory(id)
      .then(response => {
        loadData()
      })
      .catch(err => {
        $ctrl.uiState = 'ERROR';
      }).finally(()=>{
        $ctrl.notification = {
          version: null,
          plataform: ''
        }
      })
  }
}

CategoriesListController.$inject = ['CategoriesService', '$mdDialog', '$filter', '$scope', '$state', 'Toast'];

export default CategoriesListController;



// WEBPACK FOOTER //
// ./client/app/components/categories-faq/categories-list.controller.js